import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TGetDiscussionsSucceed, EGetDiscussionsActionType } from './types';
import { TDiscussion } from '../../../types/discussions';

export const getDiscussionsSucceed: (items: TDiscussion[]) => TGetDiscussionsSucceed = actionGenerator<
  EGetDiscussionsActionType.Succeed,
  TDiscussion[]
>(EGetDiscussionsActionType.Succeed);
